import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEO from "@/components/base/SEO";

const allTimeDonors = [
  {
    rank: 1,
    name: "William Fortune",
    avatar: "https://public.readdy.ai/ai/img_res/eb66e350f96f5ab2183c4ab07e86eb75.jpg",
    badge: "Platinum Angel",
    badgeColor: "bg-gradient-to-r from-slate-300 to-slate-100 text-slate-700",
    badgeIcon: "ri-vip-crown-fill",
    badgeIconColor: "text-slate-500",
    totalDonated: "$12,500",
    donations: 48,
    country: "USA",
    flag: "🇺🇸",
    title: "Lottery Winner & Philanthropist",
    giftReceived: "A hand-embroidered silk tapestry from 6 infant families across 4 countries",
    giftImage: "https://readdy.ai/api/search-image?query=beautiful%20hand%20embroidered%20silk%20tapestry%20colorful%20intricate%20pattern%20gift%20handmade%20artisan%20clean%20white%20background&width=400&height=300&seq=hof-gift1&orientation=landscape",
    message: "Every dollar I give comes back to me a thousandfold in God's blessings. These children are the future of our world.",
    infantsHelped: 48,
    countriesReached: 12,
  },
  {
    rank: 2,
    name: "Margaret Chen",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20philanthropist%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av2&orientation=squarish",
    badge: "Gold Guardian",
    badgeColor: "bg-gradient-to-r from-yellow-200 to-amber-100 text-amber-800",
    badgeIcon: "ri-medal-fill",
    badgeIconColor: "text-amber-500",
    totalDonated: "$8,200",
    donations: 31,
    country: "Canada",
    flag: "🇨🇦",
    title: "Business Owner & Angel Donor",
    giftReceived: "A handwoven basket with dried flowers and a blessing scroll from baby Lily's family",
    giftImage: "https://readdy.ai/api/search-image?query=handwoven%20basket%20dried%20flowers%20blessing%20scroll%20handmade%20gift%20artisan%20warm%20background%20clean%20studio&width=400&height=300&seq=hof-gift2&orientation=landscape",
    message: "I started with $25 and couldn't stop. The thank-you photos from the babies make me cry every time. God is real.",
    infantsHelped: 31,
    countriesReached: 8,
  },
  {
    rank: 3,
    name: "Robert Ashford",
    avatar: "https://readdy.ai/api/search-image?query=successful%20middle%20aged%20man%20kind%20smile%20portrait%20professional%20warm%20lighting%20clean%20background&width=120&height=120&seq=hof-av3&orientation=squarish",
    badge: "Gold Guardian",
    badgeColor: "bg-gradient-to-r from-yellow-200 to-amber-100 text-amber-800",
    badgeIcon: "ri-medal-fill",
    badgeIconColor: "text-amber-500",
    totalDonated: "$6,750",
    donations: 27,
    country: "UK",
    flag: "🇬🇧",
    title: "Lottery Winner",
    giftReceived: "A hand-painted ceramic bowl with a family blessing from baby Noah's family in Ethiopia",
    giftImage: "https://readdy.ai/api/search-image?query=hand%20painted%20ceramic%20bowl%20colorful%20blessing%20pattern%20handmade%20artisan%20gift%20clean%20white%20background%20studio&width=400&height=300&seq=hof-gift3&orientation=landscape",
    message: "Winning the lottery meant nothing until I found a way to share it. These babies gave my wealth a purpose.",
    infantsHelped: 27,
    countriesReached: 7,
  },
  {
    rank: 4,
    name: "Yuki Tanaka",
    avatar: "https://readdy.ai/api/search-image?query=japanese%20woman%20elegant%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av4&orientation=squarish",
    badge: "Silver Star",
    badgeColor: "bg-gradient-to-r from-gray-200 to-gray-100 text-gray-700",
    badgeIcon: "ri-star-fill",
    badgeIconColor: "text-gray-400",
    totalDonated: "$4,100",
    donations: 19,
    country: "Japan",
    flag: "🇯🇵",
    title: "Top Donor",
    giftReceived: "A handmade origami blessing set and a photo album from 3 infant families",
    giftImage: "https://readdy.ai/api/search-image?query=handmade%20origami%20paper%20cranes%20colorful%20blessing%20gift%20set%20clean%20white%20background%20artisan%20studio&width=400&height=300&seq=hof-gift4&orientation=landscape",
    message: "In Japan we say — the happiness you give returns to you multiplied. I believe this with all my heart.",
    infantsHelped: 19,
    countriesReached: 5,
  },
  {
    rank: 5,
    name: "Carlos Mendez",
    avatar: "https://readdy.ai/api/search-image?query=latin%20american%20man%20generous%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av5&orientation=squarish",
    badge: "Silver Star",
    badgeColor: "bg-gradient-to-r from-gray-200 to-gray-100 text-gray-700",
    badgeIcon: "ri-star-fill",
    badgeIconColor: "text-gray-400",
    totalDonated: "$3,300",
    donations: 15,
    country: "Brazil",
    flag: "🇧🇷",
    title: "Community Champion",
    giftReceived: "A hand-knitted baby blanket and a blessing card from baby Oliver's family in Australia",
    giftImage: "https://readdy.ai/api/search-image?query=hand%20knitted%20soft%20baby%20blanket%20pastel%20colors%20handmade%20gift%20artisan%20clean%20white%20background%20studio&width=400&height=300&seq=hof-gift5&orientation=landscape",
    message: "My children asked me why I donate. I told them — because one day someone will do the same for you.",
    infantsHelped: 15,
    countriesReached: 4,
  },
  {
    rank: 6,
    name: "Sophie Laurent",
    avatar: "https://readdy.ai/api/search-image?query=french%20woman%20elegant%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av6&orientation=squarish",
    badge: "Bronze Heart",
    badgeColor: "bg-gradient-to-r from-orange-200 to-amber-100 text-orange-800",
    badgeIcon: "ri-heart-fill",
    badgeIconColor: "text-orange-400",
    totalDonated: "$2,150",
    donations: 11,
    country: "France",
    flag: "🇫🇷",
    title: "Angel Donor",
    giftReceived: "A handmade friendship bracelet and a dried flower bouquet from baby Emma's family",
    giftImage: "https://readdy.ai/api/search-image?query=handmade%20friendship%20bracelet%20colorful%20beads%20dried%20flower%20bouquet%20gift%20clean%20white%20background%20artisan&width=400&height=300&seq=hof-gift6&orientation=landscape",
    message: "The photo of baby Emma smiling is my phone wallpaper. It reminds me every day why kindness matters.",
    infantsHelped: 11,
    countriesReached: 3,
  },
  {
    rank: 7,
    name: "James Okafor",
    avatar: "https://readdy.ai/api/search-image?query=african%20man%20kind%20generous%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av7&orientation=squarish",
    badge: "Bronze Heart",
    badgeColor: "bg-gradient-to-r from-orange-200 to-amber-100 text-orange-800",
    badgeIcon: "ri-heart-fill",
    badgeIconColor: "text-orange-400",
    totalDonated: "$1,800",
    donations: 9,
    country: "Nigeria",
    flag: "🇳🇬",
    title: "Community Champion",
    giftReceived: "A hand-carved wooden blessing token and a family prayer scroll from baby Lucas's family",
    giftImage: "https://readdy.ai/api/search-image?query=hand%20carved%20wooden%20blessing%20token%20prayer%20scroll%20handmade%20artisan%20gift%20clean%20white%20background%20studio&width=400&height=300&seq=hof-gift7&orientation=landscape",
    message: "I grew up without much. Now I can give. God has been so good to me — I must share that goodness.",
    infantsHelped: 9,
    countriesReached: 3,
  },
  {
    rank: 8,
    name: "Anna Kowalski",
    avatar: "https://readdy.ai/api/search-image?query=polish%20woman%20warm%20generous%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av8&orientation=squarish",
    badge: "Bronze Heart",
    badgeColor: "bg-gradient-to-r from-orange-200 to-amber-100 text-orange-800",
    badgeIcon: "ri-heart-fill",
    badgeIconColor: "text-orange-400",
    totalDonated: "$1,250",
    donations: 7,
    country: "Poland",
    flag: "🇵🇱",
    title: "Generous Heart",
    giftReceived: "A handmade lace doily and a blessing letter from baby Sophie's family in the UK",
    giftImage: "https://readdy.ai/api/search-image?query=handmade%20white%20lace%20doily%20blessing%20letter%20handmade%20artisan%20gift%20clean%20white%20background%20studio%20elegant&width=400&height=300&seq=hof-gift8&orientation=landscape",
    message: "Every morning I pray for the babies I've helped. And every morning I feel God's peace in my heart.",
    infantsHelped: 7,
    countriesReached: 2,
  },
  {
    rank: 9,
    name: "David Park",
    avatar: "https://readdy.ai/api/search-image?query=korean%20man%20warm%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av9&orientation=squarish",
    badge: "Rising Star",
    badgeColor: "bg-gradient-to-r from-rose-100 to-pink-50 text-rose-700",
    badgeIcon: "ri-sparkling-2-fill",
    badgeIconColor: "text-rose-400",
    totalDonated: "$850",
    donations: 5,
    country: "South Korea",
    flag: "🇰🇷",
    title: "New Donor",
    giftReceived: "A hand-painted stone with a blessing symbol from baby Max's family in New Zealand",
    giftImage: "https://readdy.ai/api/search-image?query=hand%20painted%20blessing%20stone%20colorful%20symbol%20handmade%20artisan%20gift%20clean%20white%20background%20studio&width=400&height=300&seq=hof-gift9&orientation=landscape",
    message: "I just started donating this year. The gift I received from baby Max's family made me want to give more.",
    infantsHelped: 5,
    countriesReached: 2,
  },
  {
    rank: 10,
    name: "Lisa Thompson",
    avatar: "https://readdy.ai/api/search-image?query=american%20woman%20warm%20generous%20smile%20portrait%20professional%20natural%20light%20clean%20background&width=120&height=120&seq=hof-av10&orientation=squarish",
    badge: "Rising Star",
    badgeColor: "bg-gradient-to-r from-rose-100 to-pink-50 text-rose-700",
    badgeIcon: "ri-sparkling-2-fill",
    badgeIconColor: "text-rose-400",
    totalDonated: "$600",
    donations: 4,
    country: "USA",
    flag: "🇺🇸",
    title: "Generous Heart",
    giftReceived: "A handmade pressed flower card and a family blessing photo from baby Lily's family",
    giftImage: "https://readdy.ai/api/search-image?query=handmade%20pressed%20flower%20greeting%20card%20blessing%20photo%20handmade%20artisan%20gift%20clean%20white%20background%20studio&width=400&height=300&seq=hof-gift10&orientation=landscape",
    message: "I shared this on Instagram and 3 of my friends started donating too. Love is contagious!",
    infantsHelped: 4,
    countriesReached: 1,
  },
];

const rankMedal: Record<number, { bg: string; text: string; icon: string }> = {
  1: { bg: "bg-gradient-to-b from-slate-300 to-slate-400", text: "text-white", icon: "ri-vip-crown-fill" },
  2: { bg: "bg-gradient-to-b from-yellow-300 to-amber-400", text: "text-white", icon: "ri-medal-fill" },
  3: { bg: "bg-gradient-to-b from-amber-400 to-orange-500", text: "text-white", icon: "ri-medal-fill" },
};

const overallStats = [
  { icon: "ri-trophy-fill", value: "10", label: "Hall of Fame Members", color: "text-amber-500" },
  { icon: "ri-heart-fill", value: "176", label: "Total Donations Made", color: "text-rose-500" },
  { icon: "ri-money-dollar-circle-fill", value: "$41,500+", label: "Total Donated", color: "text-green-600" },
  { icon: "ri-global-fill", value: "12", label: "Countries Reached", color: "text-orange-500" },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const infantDonationSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Infant Donation Hall of Fame — StarBookPrime",
    "description": "Meet our most generous donors who helped infants around the world. See the gifts they received from infant families and their messages of love.",
    "url": `${SITE_URL}/infant-donation`,
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
        { "@type": "ListItem", "position": 2, "name": "Infant Donation Hall of Fame", "item": `${SITE_URL}/infant-donation` }
      ]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "NGO",
    "name": "Infant Happiness Foundation",
    "description": "A charitable initiative helping infants around the world through generous donations from lottery winners and kind-hearted individuals.",
    "url": `${SITE_URL}/infant-donation`,
    "foundingDate": "2023",
    "areaServed": "Worldwide",
    "potentialAction": {
      "@type": "DonateAction",
      "name": "Donate to Infant Happiness Foundation",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${SITE_URL}/infant-donation`,
      },
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Infant Donation Hall of Fame — Top Donors",
    "description": "All-time top donors who helped infants around the world through the Infant Happiness Foundation.",
    "url": `${SITE_URL}/infant-donation`,
    "numberOfItems": 10,
    "itemListElement": allTimeDonors.map((donor, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": donor.name,
      "description": `${donor.badge} — ${donor.totalDonated} donated, ${donor.infantsHelped} infants helped across ${donor.countriesReached} countries.`,
    })),
  },
];

export default function InfantDonationPage() {
  const [selectedDonor, setSelectedDonor] = useState<number | null>(null);
  const [filter, setFilter] = useState<"all" | "lottery" | "top">("all");

  const filtered = allTimeDonors.filter((d) => {
    if (filter === "lottery") return d.title.toLowerCase().includes("lottery");
    if (filter === "top") return parseInt(d.totalDonated.replace(/[^0-9]/g, "")) >= 3000;
    return true;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <SEO
        title="Infant Donation Hall of Fame — StarBookPrime"
        description="Meet our most generous donors who helped infants around the world. See the gifts they received from infant families and their messages of love."
        keywords="infant donation, hall of fame, charity donors, baby help"
        canonical="/infant-donation"
        schema={infantDonationSchema}
      />
      <Navbar />

      {/* Hero */}
      <div className="relative w-full h-[420px] md:h-[500px] overflow-hidden pt-16">
        <img
          src="https://readdy.ai/api/search-image?query=group%20of%20happy%20blonde%20children%20babies%20toddlers%20playing%20together%20outdoors%20sunny%20golden%20light%20joyful%20celebration%20wide%20banner%20warm%20beautiful&width=1600&height=500&seq=hof-hero-banner&orientation=landscape"
          alt="Happy children"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-rose-900/70 via-rose-800/50 to-rose-900/80" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-bold uppercase tracking-widest mb-5">
            <i className="ri-trophy-fill text-yellow-300" />
            Infant Happiness Foundation
            <i className="ri-trophy-fill text-yellow-300" />
          </div>
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 leading-tight"
            style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
          >
            Donor Hall of Fame
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl leading-relaxed font-medium mb-6">
            These generous souls — lottery winners, rich hearts, and kind people — changed the lives of infants around the world. God blesses every one of them and their families.
          </p>
          <Link
            to="/#infant-donation-form"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-extrabold text-sm bg-rose-500 text-white hover:bg-rose-400 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-heart-fill" /> Join the Hall of Fame — Donate Now
          </Link>
        </div>
      </div>

      {/* Overall Stats */}
      <div className="bg-white border-b border-rose-100">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {overallStats.map((s) => (
              <div key={s.label} className="text-center p-4 rounded-2xl bg-rose-50/60 border border-rose-100">
                <div className={`w-10 h-10 flex items-center justify-center mx-auto mb-2 text-2xl ${s.color}`}>
                  <i className={s.icon} />
                </div>
                <div className="text-2xl font-extrabold text-gray-900 mb-0.5">{s.value}</div>
                <div className="text-xs text-gray-500 font-medium">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 py-14">

        {/* Filter */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-1"
              style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
            >
              All-Time Top Donors
            </h2>
            <p className="text-gray-500 text-sm">Every donor received a handmade gift from an infant family in return</p>
          </div>
          <div className="flex items-center gap-2">
            {(["all", "lottery", "top"] as const).map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-4 py-2 rounded-full text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
                  filter === f
                    ? "bg-rose-500 text-white"
                    : "bg-white border border-gray-200 text-gray-600 hover:border-rose-300"
                }`}
              >
                {f === "all" ? "All Donors" : f === "lottery" ? "Lottery Winners" : "Top $3K+"}
              </button>
            ))}
          </div>
        </div>

        {/* Top 3 Podium */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {filtered.slice(0, 3).map((donor) => (
            <div
              key={donor.rank}
              className={`relative bg-white rounded-3xl overflow-hidden border-2 transition-all cursor-pointer hover:-translate-y-1 ${
                donor.rank === 1 ? "border-slate-300" : donor.rank === 2 ? "border-amber-300" : "border-orange-300"
              }`}
              onClick={() => setSelectedDonor(selectedDonor === donor.rank ? null : donor.rank)}
            >
              {/* Rank medal */}
              <div className={`absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full ${rankMedal[donor.rank]?.bg} z-10`}>
                <i className={`${rankMedal[donor.rank]?.icon} text-lg ${rankMedal[donor.rank]?.text}`} />
              </div>

              {/* Gift image */}
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={donor.giftImage}
                  alt={`Gift for ${donor.name}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="text-white text-xs font-semibold flex items-center gap-1">
                    <i className="ri-gift-2-fill text-amber-300" /> {donor.giftReceived.slice(0, 50)}...
                  </div>
                </div>
              </div>

              <div className="p-5">
                {/* Avatar + name */}
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-rose-100 flex-shrink-0">
                    <img src={donor.avatar} alt={donor.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <div className="font-extrabold text-gray-900 text-base">{donor.name}</div>
                    <div className="text-xs text-gray-400">{donor.flag} {donor.country} · {donor.title}</div>
                    <div className={`inline-flex items-center gap-1 mt-1 px-2 py-0.5 rounded-full text-xs font-bold ${donor.badgeColor}`}>
                      <i className={`${donor.badgeIcon} ${donor.badgeIconColor} text-xs`} />
                      {donor.badge}
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-2 mb-3">
                  <div className="text-center p-2 rounded-xl bg-rose-50">
                    <div className="text-base font-extrabold text-rose-600">{donor.totalDonated}</div>
                    <div className="text-xs text-gray-400">Donated</div>
                  </div>
                  <div className="text-center p-2 rounded-xl bg-orange-50">
                    <div className="text-base font-extrabold text-orange-600">{donor.infantsHelped}</div>
                    <div className="text-xs text-gray-400">Infants</div>
                  </div>
                  <div className="text-center p-2 rounded-xl bg-amber-50">
                    <div className="text-base font-extrabold text-amber-600">{donor.countriesReached}</div>
                    <div className="text-xs text-gray-400">Countries</div>
                  </div>
                </div>

                <p className="text-xs text-gray-600 italic leading-relaxed line-clamp-2">"{donor.message}"</p>

                {selectedDonor === donor.rank && (
                  <div className="mt-3 pt-3 border-t border-rose-100 space-y-2">
                    <div className="rounded-xl bg-amber-50 border border-amber-100 p-3">
                      <div className="text-xs font-bold text-amber-700 mb-1 flex items-center gap-1">
                        <i className="ri-gift-2-fill text-orange-500" /> Gift Received
                      </div>
                      <p className="text-xs text-amber-800 leading-relaxed">{donor.giftReceived}</p>
                    </div>
                    <p className="text-xs text-gray-600 italic leading-relaxed">"{donor.message}"</p>
                  </div>
                )}

                <button className="mt-3 w-full text-xs text-rose-500 font-bold flex items-center justify-center gap-1 cursor-pointer hover:text-rose-600">
                  {selectedDonor === donor.rank ? (
                    <><i className="ri-arrow-up-s-line" /> Show Less</>
                  ) : (
                    <><i className="ri-arrow-down-s-line" /> See Full Story</>
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Remaining donors list */}
        <div className="space-y-4 mb-14">
          {filtered.slice(3).map((donor) => (
            <div
              key={donor.rank}
              className="bg-white rounded-2xl border border-rose-100 hover:border-rose-300 transition-all cursor-pointer"
              onClick={() => setSelectedDonor(selectedDonor === donor.rank ? null : donor.rank)}
            >
              <div className="p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                {/* Rank */}
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-rose-50 text-rose-500 font-extrabold text-lg flex-shrink-0">
                  #{donor.rank}
                </div>

                {/* Avatar */}
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={donor.avatar} alt={donor.name} className="w-full h-full object-cover object-top" />
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="font-extrabold text-gray-900 text-sm">{donor.name}</span>
                    <span className="text-sm">{donor.flag}</span>
                    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold ${donor.badgeColor}`}>
                      <i className={`${donor.badgeIcon} ${donor.badgeIconColor} text-xs`} />
                      {donor.badge}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 truncate">{donor.title} · {donor.country}</p>
                  {selectedDonor === donor.rank && (
                    <div className="mt-3 space-y-2">
                      <div className="rounded-xl bg-amber-50 border border-amber-100 p-3">
                        <div className="text-xs font-bold text-amber-700 mb-1 flex items-center gap-1">
                          <i className="ri-gift-2-fill text-orange-500" /> Gift Received
                        </div>
                        <p className="text-xs text-amber-800 leading-relaxed">{donor.giftReceived}</p>
                      </div>
                      <p className="text-xs text-gray-600 italic leading-relaxed">"{donor.message}"</p>
                    </div>
                  )}
                </div>

                {/* Stats */}
                <div className="flex items-center gap-4 flex-shrink-0">
                  <div className="text-center">
                    <div className="text-base font-extrabold text-rose-600">{donor.totalDonated}</div>
                    <div className="text-xs text-gray-400">Donated</div>
                  </div>
                  <div className="text-center hidden sm:block">
                    <div className="text-base font-extrabold text-orange-500">{donor.infantsHelped}</div>
                    <div className="text-xs text-gray-400">Infants</div>
                  </div>
                  <i className={`text-gray-300 text-xl ${selectedDonor === donor.rank ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Join CTA */}
        <div
          className="rounded-3xl p-10 md:p-14 text-center relative overflow-hidden"
          style={{ background: "linear-gradient(135deg, #fff0f3 0%, #ffe4e8 50%, #ffd6dc 100%)" }}
        >
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-5xl text-rose-400">
            <i className="ri-trophy-fill" />
          </div>
          <h3
            className="text-3xl md:text-4xl font-extrabold text-rose-800 mb-4"
            style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}
          >
            Your Name Could Be Here
          </h3>
          <p className="text-rose-700 text-lg font-semibold max-w-2xl mx-auto mb-8 leading-relaxed">
            Join our Hall of Fame by donating to infants in need. Even $5 earns you a place in this wall of love — and a handmade gift from an infant family. God blesses every donor's family.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              onClick={() => setTimeout(() => document.getElementById("infant-donation-form")?.scrollIntoView({ behavior: "smooth" }), 300)}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-extrabold text-base bg-rose-500 text-white hover:bg-rose-600 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-heart-fill" /> Donate Now & Join the Hall of Fame
            </Link>
            <Link
              to="/social"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-extrabold text-base bg-white text-rose-600 border-2 border-rose-200 hover:border-rose-400 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-share-forward-line" /> Share With Friends
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
